<div
  #pdf
  class="dynamic-floating-pane"
>
  <div
    (click)="$event.stopPropagation()"
    class="floating-pane-content"
    [class.loading-pdf]="!isPdfLoaded"
  >
    <ng-container *ngIf="candidate.isNotAnonymized; else notSupported">
      <ng-container *ngIf="!isLoading; else spinner">
        <div
          class="inner-loader"
          *ngIf="!isPdfLoaded && isCorrectExtension"
        >
          <mat-spinner
            [diameter]="50"
            [strokeWidth]="5"
          ></mat-spinner>
          <span class="loader-status">
            preparing pdf viewer...
          </span>
        </div>
        <mojo-pdf-viewer-adapter
          *ngIf="isCorrectExtension; else notSupported"
          (pdfLoaded)="pdfLoaded()"
          [pdfSrc]="pdfSrc"
        ></mojo-pdf-viewer-adapter>
      </ng-container>
    </ng-container>

    <!-- TEMPLATES ONLY BELOW -->
    <ng-template #notSupported>
      <div class="floating-pane-message">
        <mojo-simple-candidate
          [candidate]="candidate"
          [hardSkills]="hardSkills$ | async"
          [softSkills]="softSkills$ | async"
        >
        </mojo-simple-candidate>
      </div>
    </ng-template>

    <ng-template #spinner>
      <div class="inner-loader">
        <mat-spinner
          [diameter]="50"
          [strokeWidth]="5"
        ></mat-spinner>
        <span class="loader-status">
          downloading resume...
        </span>
      </div>
    </ng-template>

  </div>
</div>
